import { render, staticRenderFns } from "./userdaliyrecord.vue?vue&type=template&id=65983f66&scoped=true"
import script from "./userdaliyrecord.vue?vue&type=script&lang=js"
export * from "./userdaliyrecord.vue?vue&type=script&lang=js"
import style0 from "./userdaliyrecord.vue?vue&type=style&index=0&id=65983f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65983f66",
  null
  
)

export default component.exports